module.exports = __webpack_public_path__ + "static/media/SEA-201-badge.e17d086e.svg";